var map = {
	"./404.md": 474,
	"./_template.jsx": 379,
	"./index.md": 475
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;



/*****************
 ** WEBPACK FOOTER
 ** . (coffee|cjsx|ts|tsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
 ** module id = 473
 ** module chunks = 0
 **/